import React, { useState } from "react";
import { Slide } from "react-awesome-reveal";
import { FaEye, FaXmark } from "react-icons/fa6";

const ImageGrid = ({ title, images }) => {
  const [fullscreenImage, setFullscreenImage] = useState(null);

  return (
    <Slide direction="up" triggerOnce>
      <div className="w-full max-w-5xl mx-auto my-12 px-4 sm:px-6">
        {/* Clean, Modern Section Title */}
        <div className="flex items-center gap-4 mb-6">
          <h3 className="text-xl font-bold text-green-950 tracking-tight shrink-0">
            {title}
          </h3>
          <div className="h-[1px] w-full bg-stone-200" />
        </div>

        {/* Clean Unbordered Masonry Grid Layout */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {images.map((src, index) => (
            <div
              key={index}
              className="relative aspect-square group cursor-pointer rounded-xl overflow-hidden bg-stone-100 border border-stone-200/40 shadow-sm"
              onClick={() => setFullscreenImage(src)}
            >
              <img
                src={src}
                alt={`${title} view ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              {/* Glass-morphic Hover Overlay Mask */}
              <div className="absolute inset-0 bg-green-950/40 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center justify-center gap-2">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-green-950 shadow-md transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  <FaEye size={16} />
                </div>
                <span className="text-white text-xs font-semibold tracking-wider uppercase opacity-0 group-hover:opacity-100 transition-opacity delay-100">
                  Enlarge
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Glass-morphic Backdrop Fullscreen Portal Modal */}
        {fullscreenImage && (
          <div
            className="fixed inset-0 bg-stone-950/80 backdrop-blur-md flex justify-center items-center z-[100] p-4 transition-all duration-300 animate-fadeIn"
            onClick={() => setFullscreenImage(null)}
          >
            {/* Elegant Top Right Close Floating Trigger Button */}
            <button
              className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20 transition-colors border border-white/10"
              onClick={() => setFullscreenImage(null)}
            >
              <FaXmark size={20} />
            </button>

            <div className="relative max-w-4xl max-h-[85vh] overflow-hidden rounded-2xl shadow-2xl bg-stone-900 border border-white/10">
              <img
                src={fullscreenImage}
                alt="Fullscreen Preview"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        )}
      </div>
    </Slide>
  );
};

export default ImageGrid;
